<template>
  <div class="iap-home">
    <h1 :class="$style.iapTitle" type="text" placeholder="Right">IAP</h1>
    <RouterTabs v-if="pricingTemplatesEnabled" :tabs="iapTabs" :tab-with-children-routes="tabsWithChildrenRoutes" />
    <router-view />
  </div>
</template>

<script setup>
import { onMounted, computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import links from "@/router/links";
import RouterTabs from "@/components/RouterTabs";
import { PRICING_TEMPLATE_ALLOWED_APP_IDS } from "@/constants";

const router = useRouter();
const tabsWithChildrenRoutes = ref(["pricingTemplate", "appPricingTemplate"]);
const iapRoot = router.getRoutes().find((route) => route.name === links.iap.iapHome);
const iapTabs = ref(
  iapRoot.children.map((route) => ({
    name: route.name,
    label: route.meta.label || "",
    path: route.path,
  }))
);

const route = useRoute();
const pricingTemplatesEnabled = computed(() => PRICING_TEMPLATE_ALLOWED_APP_IDS.includes(route.params.gameId));

const defineIAPTabs = () => {
  const iapListRoute = iapRoot.children.find((childRoute) => childRoute.name === links.iap.iapList);
  const tabs = [
    {
      name: iapListRoute.name,
      label: iapListRoute.meta.label || "",
      path: iapListRoute.path,
    },
  ];
  if (pricingTemplatesEnabled.value) {
    const systemTemplatesRoute = iapRoot.children.find((childRoute) => childRoute.name === links.iap.pricingTemplates);
    tabs.push({
      name: systemTemplatesRoute.name,
      label: systemTemplatesRoute.meta.label || "",
      path: systemTemplatesRoute.path,
    });
    const appTemplatesRoute = iapRoot.children.find((childRoute) => childRoute.name === links.iap.appPricingTemplates);
    tabs.push({
      name: appTemplatesRoute.name,
      label: appTemplatesRoute.meta.label || "",
      path: appTemplatesRoute.path,
    });
    tabsWithChildrenRoutes.value = ["pricingTemplate", "appPricingTemplate"];
    iapTabs.value = tabs;
  }
};

onMounted(async () => {
  defineIAPTabs();
});
</script>

<style module lang="scss">
.iapTitle {
  font-size: 32px;
  margin-bottom: 1rem;
  font-weight: 700;
}
</style>
